import throttle from '@/components/common/InfiniteScroll/throttle';

/**
 * @description 滚动到离底部距离有一定距离时触发
 * @param {CallableFunction} callback 到底部距离触发的回调函数
 * @param {{bottom:number,delay:number,initialLoad:boolean}} config 配置
 * @param {()=>boolean} shouldRemoveListener 是否需要移除监听onScroll
 **/
export const onReachBottom = (
  callback: (event?: Event) => void,
  config?: { bottom?: number; delay?: number; initialLoad?: boolean },
  shouldRemoveListener?: () => boolean
) => {
  const { bottom = 300, delay = 100, initialLoad = true } = config;
  if (initialLoad) callback(); // 初始加载时触发,防止屏幕没占满时不展示相关内容
  let onScroll = throttle(delay, false, (event: Event) => {
    //窗口高度
    let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
    //滚动高度
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    //页面高度
    let documentHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

    if (documentHeight - (windowHeight + scrollTop) < bottom) {
      callback(event);
      if (shouldRemoveListener?.()) {
        window.removeEventListener('scroll', onScroll);
      }
    }
  });
  window.removeEventListener('scroll', onScroll);
  window.addEventListener('scroll', onScroll);
};
//解决移动端滚动穿透问题
export const fixedBody = () => {
  // const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
  // document.body.style.cssText = 'position:fixed;width:100%;top:-' + scrollTop + 'px;';
  document.body.style.overflow = 'hidden';
};

export const looseBody = () => {
  const body = document.body;
  body.style.position = '';
  body.style.overflow = '';
  const top = body.style.top;
  if (!top) return;
  document.body.scrollTop = document.documentElement.scrollTop = -parseInt(top);
  body.style.cssText = '';
};
